import fetchService from '../../services/api/requirements-fetch'
import { useQuery } from 'react-query'

const useItems = () => {
    const { data } = useQuery('requirements', fetchService, { staleTime: 86400000, cacheTime: 86400000 })
    return [
        data || []
    ]
}

export default useItems